import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import CKEditor from 'ckeditor4-react';
import $ from 'jquery';
import FileBase64 from 'react-file-base64';
import AppPage from '../../views/AppPage/'
const GLOBAL = require('../../Globals');

class AddEvent extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			evename: '',
			evetype: '',
			value: '',
			edate: '',
			etime: '',
			showapp: '',
			_message: '',
			alertClass: '',
			posts: [],
			type: [],
			files: [],
			_redirect: false,
		}
		this.onChange = this.onChange.bind(this);
		this.updateContent = this.updateContent.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onShowAppChange = this.onShowAppChange.bind(this);
	}

	updateContent(evt) {
		var newContent = evt.editor.getData();
		this.setState({
			content: newContent
		})
	}

	onShowAppChange(e) {

		if (e.target.checked) {

			this.state.showapp = 1;
		}
		else {

			this.state.showapp = 0;
		}
	}

	onBack(e) {

		this.setState({ _redirect: true });
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	//base64 photo
	getFiles(files) {
		this.setState({ files: files })
	}

	handleClick(dd) {

		this.state.id = dd;

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('event/deleteevent', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Event Removed Successfully',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove UserType',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}

	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('event/addevent', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Event Added Successfully!..',
					alertClass: 'alert alert-success',
					value: RichTextEditor.createEmptyValue()
				});
				document.getElementById("eveform").reset();
				this.getdata();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	componentWillMount() {

		this.getdata();
		this.getetype();
	}

	getdata() {
		$("#showLoader").show();
		GetData('event/getevents').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** get Hostel Type **/
	getetype() {

		GetData('event/geteventtype').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					type: responseJson
				});
			}
		});
	}

	render() {

		var items = this.state.type;
		if (this.state._redirect) {

			return (<Redirect to={'/events/event'} />);
		}

		return (
			<div>
				<AppPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="eveform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Add Event</strong>
										<Button outline color="primary" className="btn-right" onClick={this.onBack}>Back</Button>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="4">
												<FormGroup>
													<Label htmlFor="name">Event Name <span className="text-danger">*</span></Label>
													<Input type="text" name="evename" required onChange={this.onChange} />
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Event Type <span className="text-danger">*</span></Label>
													<select name="evetype" onChange={this.onChange} className="form-control">
														<option value="">Select Type</option>
														{
															items.map(function (item) {
																return <option value={item.id}>{item.type}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Event Date <span className="text-danger">*</span></Label>
													<Input type="date" name="edate" required onChange={this.onChange} />
												</FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<Label htmlFor="name">Event Time </Label>
													<Input type="time" name="etime" onChange={this.onChange} />
												</FormGroup>
											</Col>
											<Col md="9">
												<FormGroup>
													<Label htmlFor="name">About the event <span className="text-danger">*</span></Label>
													<CKEditor
														data={this.state.content}
														onChange={this.updateContent}
														config={{ extraPlugins: 'iframe', extraAllowedContent: '*(*);*{*}', allowedContent: true }}
													/>
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Event Photo</Label>
													<FileBase64 onDone={this.getFiles.bind(this)} />
													<input type="checkbox" id="isapp" name="showapp" onChange={this.onShowAppChange} />&nbsp;&nbsp;Show On App
								</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default AddEvent;


// WEBPACK FOOTER //
// ./src/events/Event/AddEvent.js